function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgDataAnalyse(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M60 11.999c-15.673 0-28.998 10.02-33.942 24H24C10.746 35.999 0 46.744 0 60c0 13.255 10.746 24.001 24.001 24.001l.077-.002H60c19.882 0 36-16.118 36-36s-16.118-36-36-36zm0 64H24c-8.836 0-16-7.163-16-16s7.164-16 16-16h8.298c1.942-13.566 13.599-24 27.702-24 15.464 0 28 12.536 28 28s-12.536 28-28 28z"
  }), React.createElement("path", {
    d: "M72.538 45.038c-1.264 0-2.472.236-3.596.648l-4.464-4.914a10.07 10.07 0 00.939-4.237c0-5.596-4.553-10.149-10.149-10.149s-10.149 4.553-10.149 10.149c0 .695.071 1.373.204 2.029L31.639 51.407A10.425 10.425 0 0026 49.75c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5c0-.758-.085-1.496-.238-2.209L49.97 45.174a10.075 10.075 0 005.299 1.51c1.146 0 2.244-.2 3.272-.551l4.501 4.955a10.417 10.417 0 00-1.004 4.451c0 5.79 4.71 10.5 10.5 10.5s10.5-4.71 10.5-10.5-4.71-10.501-10.5-10.501zM26 62.75c-1.378 0-2.5-1.121-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.122 2.5-2.5 2.5zm29.269-24.066c-1.186 0-2.149-.964-2.149-2.149s.964-2.149 2.149-2.149 2.149.964 2.149 2.149-.964 2.149-2.149 2.149zm17.269 19.354c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5z"
  }));
}

SvgDataAnalyse.clsName = 'icon-www__data-analyse';
SvgDataAnalyse.remarkName = 'unknown';
export default SvgDataAnalyse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/DataAnalyse.js
// module id = 2330
// module chunks = 17 18